import { gql } from '@apollo/client'

/**
 * Public session review fields (W6). `text` is null when the reviewee hid it; `author.slug` is
 * only set when the viewer may open the author's profile (L45).
 */
export const SESSION_REVIEW_FIELDS_FRAGMENT = gql`
  fragment SessionReviewFields on ScoSessionReview {
    id
    score
    text
    createdAt
    sourceKey
    isFeatured
    isTextHidden
    author {
      isMember
      name
      tagline
      imageUrl
      slug
    }
  }
`

/** Combined average + count (both sources, hidden reviews included — L40, L46). */
export const SESSION_REVIEW_SUMMARY_FIELDS_FRAGMENT = gql`
  fragment SessionReviewSummaryFields on ScoSessionReviewSummary {
    averageScore
    count
  }
`
